export const FETCH_IVR_ORDER_CONFIRMATION_CHARGES_REQUEST = "FETCH_IVR_ORDER_CONFIRMATION_CHARGES_REQUEST";
export const FETCH_IVR_ORDER_CONFIRMATION_CHARGES_SUCCESS = "FETCH_IVR_ORDER_CONFIRMATION_CHARGES_SUCCESS";
export const FETCH_IVR_ORDER_CONFIRMATION_CHARGES_FAILURE = "FETCH_IVR_ORDER_CONFIRMATION_CHARGES_FAILURE";
export const FETCH_IVR_ORDER_CONFIRMATION_CHARGES_RESET = "FETCH_IVR_ORDER_CONFIRMATION_CHARGES_RESET";
export const fetchIvrORDERConfirmationChargesRequest = (payload) => ({
    type: FETCH_IVR_ORDER_CONFIRMATION_CHARGES_REQUEST,
    payload,
});
export const fetchIvrORDERConfirmationChargesSuccess = (payload) => ({
    type: FETCH_IVR_ORDER_CONFIRMATION_CHARGES_SUCCESS,
    payload,
});
export const fetchIvrORDERConfirmationChargesFailure = (payload) => ({
    type: FETCH_IVR_ORDER_CONFIRMATION_CHARGES_FAILURE,
    payload,
});
export const fetchIvrORDERConfirmationChargesReset = () => ({
    type: FETCH_IVR_ORDER_CONFIRMATION_CHARGES_RESET,
});
